// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"516":"1ff4c46c","765":"d7885511"}[chunkId] + ".chunk.js";
};